import type { Event, MeEventsResponse } from "@mvk/shared";
import { apiRequest } from "./client";

export const meApi = {
  getEvents(): Promise<MeEventsResponse> {
    return apiRequest<MeEventsResponse>("/me/events", { audience: "visitor" });
  },
};

export const eventsApi = {
  list(): Promise<{ events: Event[] }> {
    return apiRequest<{ events: Event[] }>("/events");
  },
};
